import React from "react";
import { Box, styled, Typography, useTheme } from "@mui/material";
import { CenteredSiteBlock } from "../../routes/Home";
import { GradientTypo } from "../header/Header";

import { ReactComponent as FindSupportIcon } from "../../resources/images/svg/home/users.svg";
import businessWomanImage from "../../resources/images/png/home/businessWoman.png";
import RainbowDivider from "../misc/RainbowDivider";
import FindSupportCards from "./FindSupportCards";
import InexButton from "../InexButton";
import { useIsMobile } from "../../hooks/responsive";
import { useIsSubscribed } from "../../hooks/auth";

const Container = styled(Box)(({ theme }) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
    minHeight: "100px",
    backgroundColor: theme.palette.blackPro,
    backgroundImage: `url(${businessWomanImage})`,
    backgroundOpacity: 0.22,
  };
});

const redirectToSubscribe = () => {
  window
    .open(
      `https://abonnements.inexplore.com/je-mabonne?selectedAbos=[3,4]`,
      "_blank",
    )
    .focus();
};

const FindSupport = () => {
  const theme = useTheme();
  const isSubscribed = useIsSubscribed();

  return (
    <Container className={"ambitions"}>
      <CenteredSiteBlock>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            mt: 7,
            mb: 7,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <FindSupportIcon
              width={"62px"}
              height={"62px"}
              style={{
                marginRight: "20px",
              }}
            />
            <Typography
              variant="h2"
              sx={{
                fontWeight: 500,
                margin: 0,
                textAlign: "center",
                color: "white",
              }}
            >
              Trouvez un soutien
            </Typography>
            <GradientTypo
              variant={"h2"}
              background={theme.palette.linearPro}
              sx={{
                fontFamily: "YesevaOne",
                textTransform: "lowercase",
                textAlign: "center",
                margin: 0,
                fontWeight: 500,
                "&:first-letter": {
                  textTransform: "lowercase !important",
                },
              }}
            >
              &nbsp;{`de qualité`}
            </GradientTypo>
          </Box>
          <Typography
            variant="p"
            sx={{
              fontWeight: 500,
              margin: 0,
              textAlign: "center",
              color: "white",
              fontFamily: "Branding SemiBold",
              fontSize: 18,
              mt: 4,
              mb: 4,
              mr: "5vw",
              ml: "5vw",
            }}
          >
            Des outils concrets et un réseau humain pour avancer sereinement, en
            confiance et gagner en puissance dans votre pratique
          </Typography>
          <FindSupportCards />
            <InexButton
              text={"Je m'abonne pour en profiter"}
              variant={"text"}
              textWithGradient={false}
              onClick={redirectToSubscribe}
              sx={{
                zIndex: 1,
                marginBottom: 2,
                marginTop: 5,
                width: "300px",
                height: "50px",
                background: (theme) => theme.palette.primary.main,
                border: (theme) => theme.palette.primary.main + " solid 3px",
                color: "white",
                "&:hover": {
                  backgroundColor: "white",
                  "& > p": {
                    color: (theme) => theme.palette.primary.main,
                  },
                },
              }}
            />
        </Box>
      </CenteredSiteBlock>
      <RainbowDivider />
    </Container>
  );
};

export default FindSupport;
